export enum OtherAssetType {
  Business,
  RealEstate,
  Pension,
  Miscellaneous,
  DeferredCompensation,
}

export const ASSET_NAME_MAP: Record<OtherAssetType, string> = {
  [OtherAssetType.Business]: 'Business Asset',
  [OtherAssetType.RealEstate]: 'Real Estate',
  [OtherAssetType.Pension]: 'Pension',
  [OtherAssetType.Miscellaneous]: 'Miscellaneous Asset',
  [OtherAssetType.DeferredCompensation]: 'Deferred Compensation',
};

export interface EarmarkDTO {
  Type: string;
  Tooltip: string;
}

export interface EarmarkOptionDTO {
  label: string;
  value: string;
}

export interface OwnerOptionDTO {
  Id: string | null;
  Name: string;
  OwnerType: number;
}

export interface OwnerOptionsDTO {
  People: OwnerOptionDTO[];
  Trusts: OwnerOptionDTO[];
}

export interface ColumnHeader {
  text: string;
  align?: 'left' | 'center' | 'right';
}

export enum OwnerTypeDTO {
  Principal = 0,
  Spouse = 1,
  Joint = 2,
  Trust = 3,
  Business = 4,
  Child = 5,
  Grandchild = 6,
  OtherDependent = 7,
  OtherBeneficiary = 8,
  OtherIndividual = 9,
}
export interface OwnerModelDTO {
  Id: string | null;
  Name: string;
  OwnerType: OwnerTypeDTO;
  Percentage: number;
}

export interface OwnerModelFormDTO {
  Id?: string | null;
  Name?: string;
  OwnerType?: OwnerTypeDTO;
  Percentage?: string;
}

export const ADD_ASSET_SUCCESS_MESSAGE = 'New asset added successfully.';
export const EDIT_ASSET_SUCCESS_MESSAGE = 'The asset saved successfully.';
export const CLONE_ASSET_SUCCESS_MESSAGE = 'Asset cloned successfully.';

export const APPEND_ASSET_OWNER = { Id: null, Name: '', OwnerType: 0, Percentage: '' };

export const OWNERTYPE_MAP = {
  [OwnerTypeDTO.Principal]: 'Principal',
  [OwnerTypeDTO.Spouse]: 'Spouse',
  [OwnerTypeDTO.Joint]: 'Joint',
  [OwnerTypeDTO.Trust]: 'Trust',
  [OwnerTypeDTO.Business]: 'Business',
  [OwnerTypeDTO.Child]: 'Child',
  [OwnerTypeDTO.Grandchild]: 'Grandchild',
  [OwnerTypeDTO.OtherDependent]: 'Other Dependent',
  [OwnerTypeDTO.OtherBeneficiary]: 'Other Beneficiary',
  [OwnerTypeDTO.OtherIndividual]: 'Other Individual',
};
